module.exports = __webpack_public_path__ + "static/media/ICT4U_1.c7c71b8b.jpeg";